import React, { useState, useContext, useEffect } from 'react'
import axios from 'axios'
import { DispatchContext } from '../../AppContext'
import { baseApiURL } from 'src/utils/utils'
import { useHistory } from 'react-router'
import styles from './frontpage.module.scss'
import Input from 'src/components/input/Input'
import { Link } from 'react-router-dom'
import Button from 'src/components/button/Button'
import cookie from 'cookie_js'
import { validEmail, validPassword, resetError, handleInputChange, handleValidation } from 'src/utils/utils'
import { toast } from 'react-toastify'
import { IState } from 'src/Interface'
import { StateContext } from 'src/AppContext'
import { gaLogin } from 'src/utils/ga/ga'
import { gaUserParameterMapper } from 'src/utils/ga/gaMapper'

interface IValues {
  email: string
  password: string
}

interface IErrors {
  email: boolean
  password: boolean
}

const Login: React.FunctionComponent = () => {
  const dispatch: React.Dispatch<any> = useContext(DispatchContext)
  const state: IState = useContext(StateContext)
  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory()
  const [inCorrectCredentials, setInCorrectCredentials] = useState(false)
  const [errors, setErrors] = useState<IErrors>({
    email: false,
    password: false
  })
  const [values, setValues] = useState<IValues>({
    email: '',
    password: ''
  })

  useEffect(() => {
    if (cookie.get('access_token') || cookie.get('refresh_token')) {
      history.push('/order')
    }
  }, [history])


  const login = (e) => {
    e.preventDefault()
    // Clear any previous validation errors before attempting login
    setErrors({ email: false, password: false })
    setInCorrectCredentials(false)
    setIsLoading(true)
    axios.post(`${baseApiURL()}/login`, {
      username: values.email,
      password: values.password
    }).then((result: any) => {
      setIsLoading(false)
      cookie.set('user_id', result.data.userId, {
        expires: new Date(new Date().getTime() + 50 * 60 * 1000), // expires in 50 hour
        path: '/',
        secure: true,
        sameSite: 'strict'
      })
      cookie.set('access_token', result.data.access_token, {
        expires: new Date(new Date().getTime() + 50 * 60 * 1000), // expires in 50 hour
        path: '/',
        secure: true,
        sameSite: 'strict'
      })
      cookie.set('refresh_token', result.data.refresh_token, {
        expires: 1, // expires in 24 hour
        path: '/',
        secure: true,
        sameSite: 'strict'
      })
      dispatch({
        type: 'SET_USER_INFO',
        user: {
          accessToken: result.data.access_token,
          id: result.data.userId
        }
      })
      gaLogin(gaUserParameterMapper(result.data.userId, result.data.roles[0]))
      history.push('/order')
    }).catch((err) => {
      setIsLoading(false)
      setErrors({ email: false, password: false })
      toast(err.response.data.message)
      setInCorrectCredentials(true)
    })
  }

  return (
    <>
      <div className={styles.module}>
        <form onSubmit={login}>
          <Input
            name='email'
            label='E-mail'
            placeholder='Indtast din arbejdsmail'
            value={values.email}
            type='email'
            error={errors.email || inCorrectCredentials}
            resetError={() => resetError('email', setErrors, errors, setInCorrectCredentials)}
            handleValidation={() => handleValidation(validEmail, 'email', setErrors, errors)}
            handleInputChange={() => handleInputChange('email', setValues, values)}
          />
          {errors.email && !inCorrectCredentials && <p className='errorMsg'>Emailen ser ikke ud til at være i et korrekt format.</p>}
          <Input
            name='password'
            label='Kodeord'
            value={values.password}
            modifiers='tw-my-3'
            error={errors.password || inCorrectCredentials}
            resetError={() => resetError('password', setErrors, errors, setInCorrectCredentials)}
            placeholder='Indtast dit kodeord'
            type='password'
            handleInputChange={() => handleInputChange('password', setValues, values)}
          />
          {inCorrectCredentials && <p className='errorMsg'>Email eller password er ikke korrekt.</p>}
          <Button
            label='Log ind'
            type='primary'
            submit={true}
            loading={isLoading}
            modifiers='mt-5 tw-w-full tw-justify-center'
            disabled={!(values.email && values.password) || errors.email}
          />
        </form>
      </div>
      <Link to='/resetPassword' className={styles.forgotPassword}>Glemt kodeord</Link>
    </>
  )
}

export default Login